var DIABEC_API_BASE = 'https://diabec-website.pages.dev';
/* Diabec — Track Your Order page logic.
 * Calls the same-origin /api/track-order proxy (which talks to AfterShip
 * server-side) and renders status, a 4-step progress stepper, ETA and a
 * checkpoint timeline. No PII collected; tracking number only. */
(function () {
    'use strict';

    var form = document.getElementById('trackForm');
    if (!form) return;
    var input = document.getElementById('trackNumber');
    var courier = document.getElementById('trackCourier');
    var btn = document.getElementById('trackBtn');
    var msg = document.getElementById('trackMsg');
    var result = document.getElementById('trackResult');

    var TN_RE = /^[A-Za-z0-9-]{5,40}$/;

    // AfterShip tag → { step (0..3), badge class, label, problem }
    var TAGS = {
        Pending:            { step: 0, cls: 't-pending',   label: 'Pending' },
        InfoReceived:       { step: 0, cls: 't-pending',   label: 'Info Received' },
        InTransit:          { step: 1, cls: 't-transit',   label: 'In Transit' },
        OutForDelivery:     { step: 2, cls: 't-transit',   label: 'Out for Delivery' },
        AvailableForPickup: { step: 2, cls: 't-transit',   label: 'Ready for Pickup' },
        AttemptFail:        { step: 2, cls: 't-problem',   label: 'Delivery Attempted', problem: true },
        Delivered:          { step: 3, cls: 't-delivered', label: 'Delivered' },
        Exception:          { step: 1, cls: 't-problem',   label: 'Exception', problem: true },
        Expired:            { step: 1, cls: 't-problem',   label: 'Expired', problem: true }
    };
    var STEP_LABELS = ['Info Received', 'In Transit', 'Out for Delivery', 'Delivered'];

    function esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function titleizeSlug(slug) {
        if (!slug) return '';
        return slug.split('-').map(function (w) {
            return w ? w.charAt(0).toUpperCase() + w.slice(1) : w;
        }).join(' ');
    }

    function fmtDate(iso, withTime) {
        if (!iso) return '';
        var d = new Date(iso);
        if (isNaN(d.getTime())) return esc(iso);
        try {
            var opts = withTime
                ? { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
                : { day: 'numeric', month: 'long', year: 'numeric' };
            return new Intl.DateTimeFormat('en-GB', opts).format(d);
        } catch (e) {
            return esc(iso);
        }
    }

    function setMsg(text, isError) {
        msg.textContent = text || '';
        msg.className = 'track-msg' + (isError ? ' is-error' : '');
    }

    function loading(on) {
        btn.disabled = on;
        if (on) {
            btn.innerHTML = '<span class="track-spinner" aria-hidden="true"></span>Searching…';
        } else {
            btn.textContent = 'Track';
        }
    }

    function render(data) {
        var info = TAGS[data.status] || { step: 0, cls: 't-pending', label: data.status || 'Pending' };
        var carrier = titleizeSlug(data.carrier);

        var html = '';
        html += '<div class="tr-head">';
        html += '<div class="tr-top">';
        html += '<span class="tr-num">Tracking <strong>' + esc(data.tracking_number) + '</strong></span>';
        html += '<span class="tr-badge ' + info.cls + '">' + esc(info.label) + '</span>';
        html += '</div>';
        if (data.estimated_delivery && data.status !== 'Delivered') {
            html += '<p class="tr-eta">Estimated delivery: <strong>' + fmtDate(data.estimated_delivery, false) + '</strong></p>';
        } else if (data.status === 'Delivered' && data.last_update) {
            html += '<p class="tr-eta">Delivered <strong>' + fmtDate(data.last_update, true) + '</strong></p>';
        }
        var courierBits = [];
        if (carrier) courierBits.push('Carrier: ' + esc(carrier));
        if (data.courier_link) courierBits.push('<a href="' + esc(data.courier_link) + '" target="_blank" rel="noopener noreferrer">View on carrier site &rsaquo;</a>');
        if (courierBits.length) html += '<p class="tr-courier">' + courierBits.join(' &middot; ') + '</p>';
        html += '</div>';

        // Stepper
        html += '<ol class="tr-steps' + (info.problem ? ' is-problem' : '') + '" aria-label="Delivery progress">';
        for (var i = 0; i < STEP_LABELS.length; i++) {
            var cls = '';
            if (i < info.step) cls = 'done';
            else if (i === info.step) cls = 'done current';
            html += '<li class="tr-step ' + cls + '">' + STEP_LABELS[i] + '</li>';
        }
        html += '</ol>';

        // Timeline
        var cps = data.checkpoints || [];
        if (cps.length) {
            html += '<h2 class="tr-tl-title">Tracking history</h2>';
            html += '<ul class="tr-timeline">';
            for (var j = 0; j < cps.length; j++) {
                var cp = cps[j];
                var meta = [];
                if (cp.time) meta.push(fmtDate(cp.time, true));
                if (cp.location) meta.push(esc(cp.location));
                html += '<li class="tr-event">';
                html += '<div class="tr-ev-msg">' + (esc(cp.message) || 'Update') + '</div>';
                if (meta.length) html += '<div class="tr-ev-meta">' + meta.join(' &middot; ') + '</div>';
                html += '</li>';
            }
            html += '</ul>';
        } else {
            html += '<p class="tr-empty">No tracking events yet. Your parcel is registered with the carrier — checkpoints usually appear within 24&ndash;48 hours of dispatch. Check back soon.</p>';
        }

        result.innerHTML = html;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'track_order_lookup', { status: data.status || 'unknown' });
        }
    }

    function lookup(number, slug) {
        number = (number || '').trim();
        if (!TN_RE.test(number)) {
            setMsg('Please enter a valid tracking number (letters and numbers, no spaces).', true);
            input.focus();
            return;
        }
        setMsg('');
        result.hidden = true;
        loading(true);

        var url = DIABEC_API_BASE + '/api/track-order?tracking_number=' + encodeURIComponent(number);
        if (slug) url += '&slug=' + encodeURIComponent(slug);

        fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
            .then(function (r) {
                return r.json().catch(function () { return {}; }).then(function (body) {
                    return { status: r.status, body: body };
                });
            })
            .then(function (res) {
                loading(false);
                if (res.status === 200 && res.body && !res.body.error) {
                    setMsg('');
                    render(res.body);
                    return;
                }
                var err = (res.body && res.body.error) || 'error';
                if (res.status === 404 || err === 'not_found') {
                    setMsg("We couldn't find that tracking number yet. It can take 24–48 hours after dispatch to appear — please try again later, or email support@dia-bec.com.", true);
                } else if (err === 'invalid_tracking') {
                    setMsg('That doesn’t look like a valid tracking number. Please double-check your dispatch email.', true);
                } else if (res.status === 429 || err === 'rate_limited') {
                    setMsg('Too many lookups right now. Please wait a few minutes and try again.', true);
                } else if (res.status === 503 || err === 'tracking_not_configured') {
                    setMsg('Live tracking is temporarily unavailable. Please email support@dia-bec.com with your order number and we’ll help.', true);
                } else {
                    setMsg('Something went wrong fetching your tracking. Please try again in a moment.', true);
                }
            })
            .catch(function () {
                loading(false);
                setMsg('Network error. Please check your connection and try again.', true);
            });
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();
        lookup(input.value, courier.value);
    });

    // Deep-link: /diabec-track-order.html?number=XXXX[&courier=slug]
    try {
        var qs = new URLSearchParams(window.location.search);
        var n = qs.get('number') || qs.get('tracking_number');
        var c = qs.get('courier') || qs.get('slug');
        if (n) {
            input.value = n;
            if (c) {
                courier.value = c;
                // if the slug isn't in the dropdown, fall back to auto-detect
                if (courier.value !== c) courier.value = '';
            }
            lookup(n, c || '');
        }
    } catch (e) { /* no-op */ }
})();
